import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { SidebarProvider } from "./components/ContextAPI/SidebarContext";
import "./App.css";
import Index from "./components/Routes";
import AppLogout from "./components/AutoLogout/AutoLogout";
import { ProfileProvider } from "./components/ContextAPI/ProfileContext";
import { SidebarDeskProvider } from "./components/ContextAPI/SidebarContextDesktop";
import ScrollToTop from "./components/Common/ScrollToTop";

// Same Inter stack as Tenant / DataTable (MUI otherwise defaults to Roboto).
const appTheme = createTheme({
  typography: {
    fontFamily: "var(--app-font)",
    button: { textTransform: "none", fontFamily: "var(--app-font)" },
  },
});

function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <AppLogout>
        <SidebarDeskProvider>
          <SidebarProvider>
            <ProfileProvider>
              <Router>
                <ScrollToTop />
                <div className="App">
                  <Index />
                </div>
              </Router>
            </ProfileProvider>
          </SidebarProvider>
        </SidebarDeskProvider>
      </AppLogout>
    </ThemeProvider>
  );
}

export default App;
